import { render } from "./picking-queue.vue?vue&type=template&id=5f17c391"
import script from "./picking-queue.vue?vue&type=script&lang=js"
export * from "./picking-queue.vue?vue&type=script&lang=js"

import "./picking-queue.vue?vue&type=style&index=0&id=5f17c391&lang=css"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import qInstall from "../../../../../../../../oarus-app/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSlideTransition});
